import SwitchFilter from "../../../../components/filters/SwitchFilter";
import { filterName } from "./utils";

export const getAppFilters = (params) => [
  <SwitchFilter
    filterName={filterName.APP_USING_AI}
    label="Apps using AI"
    appliedFilters={params.appliedFilters}
    setAppliedFilters={params.setAppliedFilters}
  />,
];
